import React from 'react';
import WordCloud from "react-d3-cloud";
import theme from "../../theme";


const maxLength = 30;

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
}

const WordCloudD3 = ({ chartData }) => {

  const getChartArray = chartData && Object.entries(chartData).map(el => ({
    "text": el[0],
    "value": parseFloat(el[1]) * 250
  }))

  const data = getChartArray && getChartArray.sort((a, b) => b.value - a.value).slice(0, 30);

  const truncatedData = data && data.map(item => ({
    ...item,
    text: truncateText(item.text, maxLength)
  }))

  // console.log('getChartArray', getChartArray);
  // console.log('data', data);

  const fontSizeMapper = (word, index, words) => {
    const baseFontSize = 12; // 基礎字體大小
    const scaleFactor = 0.5; // 字體大小的縮放程度

    if (index < 3) {
      return Math.log2(word.value) * scaleFactor + baseFontSize + 3;
    }
    return Math.log2(word.value) * scaleFactor + baseFontSize;
  };

  return (
    <>
      {
        data &&
        <WordCloud
          data={data?.length > 10 ? truncatedData : data}
          width={500}
          height={280}
          font="Times"
          // fontStyle="italic"
          fontWeight="bold"
          fontSize={fontSizeMapper}
          // fontSize={(word) => Math.log2(word.value) * 5}
          // fill={theme.palette.primary.main}
          fill={(word, index) => {
            if (index < 3) {
              return theme.palette.secondary.main;
            } else if (index >= 3 && index < 8) {
              return theme.palette.primary.w300;
            } else if (index >= 8) {
              return theme.palette.primary.w100;
            }
          }}
          // spiral="rectangular"
          spiral="archimedean"
          padding={1}
          // random={Math.random}
          // rotate={(word) => word.value % 10}
          rotate={() => 0}
          animate={false}
        // onWordMouseOver={(event, d) => {
        //   console.log(`onWordMouseOver: ${d.text}`);
        // }}
        />
      }
    </>
  )
}

export default WordCloudD3;
